import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-people',
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.scss']
})
export class PeopleComponent implements OnInit {

  public peopleDetails = [
  {
    "name": "Ra******* r",
    "profile": 'https://media.licdn.com/dms/image/C5103AQGmUIkdliSyCQ/profile-displayphoto-shrink_800_800/0?e=1568246400&v=beta&t=ISX7TTUlTbeYmHKPW-3YnH9lg0WUWx3xWcopYI1IZBs',
    "email": 'abc.*******@*****l.com',
    "fb_profile": "https://www.facebook.com",
    "linkedIn_profile": 'https://linkedin.com/in/r4549a7153/',
    "twitter_profile": 'https://www.twitter.com',
    'status': ["6 Sent", "3 Cliked", '0 Breached'],
    "credentials": [{"username": "rrnjith1", "pass": "ra*****21#", "icon":"fb"}],
    "weaknesses": ["7", "3", "4", "5"]
  }]

  public newProfile = {};
  constructor(
    private modalService: BsModalService,
    private modalRef: BsModalRef,
  ) { }

  ngOnInit() {
  }
  deleteThis(indes) {
    console.log(indes)
    this.peopleDetails.splice(indes, 1);
  }
  openAddNew(template: TemplateRef<any>, ip = {}) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static', keyboard: false, class: 'min-width-dialog-modal' });
  }
  submitProfile() {
    if (this.newProfile['name'] && this.newProfile['email']) {
      // this.peopleDetails.unshift(this.newProfile);
      this.modalRef.hide();
    }
  }
}
